<template>
  <b-container id="open-requests">
    <requests-list
      request-api-path="/request/open"
      request-details-route="/open-requests"
    />
  </b-container>
</template>

<script>
import RequestsList from "../components/RequestsList";

export default {
  name: "OpenRequests",
  components: { RequestsList }
};
</script>

<style scoped></style>
